<script>
    import { replace } from "svelte-spa-router";
    export let params = {};
    if (params.id) {
        replace(`/release/${params.id}`);
    }
</script>
